// tslint:disable:max-line-length

import React from 'react';

export const LogoOpengov = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0c4.4,0,8,3.6,8,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8C0,3.6,3.6,0,8,0z M8,1.9C4.6,1.9,1.9,4.6,1.9,8 s2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1S11.4,1.9,8,1.9z M11.1,5.7c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0,0.3l0,0l-3.1,5.7 C8.2,11.9,8.1,12,8,12c0,0,0,0-0.1,0c-0.1,0-0.2-0.2-0.2-0.3l0,0V8.2l-3-1.9C4.6,6.2,4.5,6.1,4.6,5.9c0-0.1,0.1-0.2,0.3-0.2l0,0 H11.1z" />
    </svg>
  );
};
